import { RouterOutlet } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { filter, map } from "rxjs/operators";
import { normalizeSnackbarMessage } from "app/shared/utils/snackbar-message-normalizer.util";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  constructor(
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private snackBar: MatSnackBar
  ) {
    this.installSnackBarMessageNormalizer();
  }
  private installSnackBarMessageNormalizer(): void {
    const snackBar = this.snackBar as MatSnackBar & {
      __tprmMessageNormalizerInstalled?: boolean;
    };

    if (snackBar.__tprmMessageNormalizerInstalled) {
      return;
    }

    const originalOpen = snackBar.open.bind(snackBar);
    snackBar.open = ((message: string, action = "", config?: any) =>
      originalOpen(
        normalizeSnackbarMessage(message),
        action,
        config
      )) as MatSnackBar["open"];
    snackBar.__tprmMessageNormalizerInstalled = true;
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child?.firstChild) {
            child = child.firstChild;
          }
          return child?.snapshot.data["title"];
        })
      )
      .subscribe((pageTitle: string) => {
        if (pageTitle) {
          this.titleService.setTitle(pageTitle);
        }
      });
  }
}
